import { request } from 'graphql-request';
import useSWR, { Fetcher, SWRConfiguration } from 'swr';

import config from '@/core/config/config';
import { USER_LOCATION } from '@/graphql/queries/apps/userLocation';
import { UserLocation } from '@/types';

const options: SWRConfiguration = {
  revalidateOnFocus: false,
  revalidateOnReconnect: true,
};

export const fetcher: Fetcher<{ userLocation: UserLocation }, [string, string]> = ([
  query,
  locationId,
]) => request(config.APPS_SERVER, query, { locationId });

export const useUserLocation = () => {
  const { data, error, isValidating, isLoading } = useSWR([USER_LOCATION], fetcher, options);
  return { data: data?.userLocation || null, error, isValidating, isLoading };
};
